import classNames from 'classnames';
import { memo, ReactNode } from 'react';
import styles from './IconMenu.module.scss';

type IconMenuProps = {
  fullWidth?: boolean;
  headline?: string;
  hasMarginBottom?: boolean;
  hasMarginTop?: boolean;
  noWrap?: boolean;
  children?: ReactNode | undefined;
  className?: string;
};

const IconMenuComponent = ({
  fullWidth = false,
  headline,
  hasMarginTop,
  hasMarginBottom,
  noWrap,
  children,
  className,
}: IconMenuProps) => {
  const classes = classNames(
    styles['icon-menu'],
    {
      [styles['full-width']]: fullWidth,
      [styles['margin-top']]: hasMarginTop,
      [styles['margin-bottom']]: hasMarginBottom,
    },
    className,
  );

  const childrenClasses = classNames(styles.children, {
    [styles['no-wrap']]: noWrap,
  });

  return (
    <div className={classes}>
      {headline && <div className={styles.headline}>{headline}</div>}
      <div className={childrenClasses}>{children}</div>
    </div>
  );
};

IconMenuComponent.displayName = 'IconMenu';

export const IconMenu = memo(IconMenuComponent);
